import React from "react";
import { inputErrorMessage } from "../Form/inputStyles";

type ErrorsProps = {
  errors: {
    hasLoginError: boolean;
    hasCaptchaError: boolean;
    hasLoginEmailLinkError: boolean;
    hasServerError: boolean;
  };
};

const Errors = ({ errors }: ErrorsProps) => {
  // if error is loginEmailLinkError, we set the error directly on the email input
  const hasOtherErrors = Object.entries(errors).some(
    ([key, value]) => key !== "hasLoginEmailLinkError" && value,
  );

  if (errors.hasLoginEmailLinkError && !hasOtherErrors) {
    return null;
  }

  const errorMessages: {
    key: keyof typeof errors;
    message: React.ReactNode;
  }[] = [
    {
      key: "hasLoginError",
      message: (
        <>
          You entered incorrect login information, try again or{" "}
          <a href="/resetpassword-myaccount.html">reset your password</a>.
        </>
      ),
    },
    {
      key: "hasCaptchaError",
      message: "You've entered the Captcha incorrectly. Please try again.",
    },
    {
      key: "hasLoginEmailLinkError",
      message: "An error occurred during the request. Please try again.",
    },
    {
      key: "hasServerError",
      message: "We were unable to validate your information. Please try again.",
    },
  ];

  return (
    <div className="mt-3 relative" aria-live="polite">
      {errorMessages.map(({ key, message }) =>
        errors[key] ? (
          <div key={key} className={`${inputErrorMessage} relative`}>
            {message}
          </div>
        ) : null,
      )}
    </div>
  );
};

export default Errors;
